import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDarkMode } from "@rbnd/react-dark-mode";
import { useTranslation } from "react-i18next";
import { teacher } from "../puglins/Utils/models";
import { isPhoneScreen } from "../helper/phoneScreen";
import { onComputerHint } from "../helper/teacherPresence";
import { PlanningModalStyle, PlanningUi } from "./styles/planningUi";

// Si la fenêtre ne peut pas s'afficher, le prof passe en ligne quand même
class Garde extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch() {
    this.props.onError();
  }
  render() {
    return this.state.failed ? null : this.props.children;
  }
}

// 💻 Prof qui passe en ligne depuis un téléphone (tour 49) : « Pour donner vos cours, préférez un
// ordinateur… », avec « Ne plus me le rappeler », « Passer en ligne » et « Annuler ». À chaque
// passage en ligne au téléphone (helper/teacherPresence.js, goOnline), jusqu'à la case cochée,
// gardée sur le compte (computer_hint_off). Rien sur tablette ni ordinateur (helper/phoneScreen.js).
// Le choix qui ne s'enregistre pas ne bloque rien.
const ComputerHint = ({ authUserData }) => {
  const { t } = useTranslation();
  const { mode } = useDarkMode();
  const [answer, setAnswer] = useState(null);
  const [remember, setRemember] = useState(false);
  const off = useRef(!!authUserData?.computer_hint_off);

  useEffect(() => {
    if (authUserData?.computer_hint_off) off.current = true;
  }, [authUserData?.computer_hint_off]);

  useEffect(
    () =>
      onComputerHint((resolve) => {
        if (off.current || !isPhoneScreen()) return resolve(true);
        setRemember(false);
        setAnswer(() => resolve);
      }),
    []
  );

  if (!answer) return null;
  const finish = (goOnline) => {
    if (remember) {
      off.current = true;
      Promise.resolve()
        .then(() => teacher.setComputerHint(true))
        .catch(() => {});
    }
    setAnswer(null);
    answer(goOnline);
  };

  return (
    <Garde onError={() => finish(true)}>
      <PlanningModalStyle />
      <Modal show onHide={() => finish(false)} centered className="acd-modal" aria-labelledby="computer-hint-texte">
        <Modal.Body data-testid="computer-hint">
          <PlanningUi mode={mode} className="p-4">
            <p id="computer-hint-texte" className="mb-3">
              {t("nd.computerHint.text")}
            </p>
            <label className="d-flex align-items-center gap-2 mb-4" htmlFor="computer-hint-case">
              <input id="computer-hint-case" type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
              {t("nd.computerHint.remember")}
            </label>
            <div className="acd-actions">
              <button type="button" className="acd-btn acd-btn-ghost" onClick={() => finish(false)}>
                {t("nd.computerHint.cancel")}
              </button>
              <button type="button" className="acd-btn acd-btn-primary" onClick={() => finish(true)}>
                {t("nd.computerHint.goOnline")}
              </button>
            </div>
          </PlanningUi>
        </Modal.Body>
      </Modal>
    </Garde>
  );
};

export default ComputerHint;
